import { FormikErrors } from 'formik';
import { useTranslation } from 'react-i18next';

import { Panel } from 'components/containers';
import { FormLayout } from 'components/form/formLayout/formLayout';
import { FormFieldDescription } from 'components/form/formLayout/types';
import { Input, InputType } from 'components/inputs';

import LABELS, { FORM_FIELDS, FormFieldType } from '../keys';
import { FormContainer } from '../styles';

interface TaxRefundFormProps {
  readOnlyMode: boolean;
  values: Record<FormFieldType, string>;
  error?: FormikErrors<Record<FormFieldType, string>>;
  setFieldValue: (field: FormFieldType, value: string) => void;
}

const TaxRefundForm = ({ readOnlyMode, values, setFieldValue, error }: TaxRefundFormProps) => {
  const { t } = useTranslation();

  const fields: FormFieldDescription[] = [
    {
      key: FORM_FIELDS.CURRENCY,
      label: t(LABELS.FORM_FIELDS.LABELS[FORM_FIELDS.CURRENCY]),
      renderInput: () => values[FORM_FIELDS.CURRENCY],
    },
    {
      key: FORM_FIELDS.FIAT_AMOUNT,
      label: t(LABELS.FORM_FIELDS.LABELS[FORM_FIELDS.FIAT_AMOUNT]),
      renderInput: ({ readonly }) => (
        <Input
          fullWidth
          type={InputType.Number}
          value={values?.[FORM_FIELDS.FIAT_AMOUNT]}
          onChange={(value) => setFieldValue(FORM_FIELDS.FIAT_AMOUNT, value)}
          disabled={readonly}
          placeholder={t(LABELS.FORM_FIELDS.PLACEHOLDERS[FORM_FIELDS.FIAT_AMOUNT])}
        />
      ),
    },
    {
      key: FORM_FIELDS.EXTERNAL_PAYOUT_ID,
      label: t(LABELS.FORM_FIELDS.LABELS[FORM_FIELDS.EXTERNAL_PAYOUT_ID]),
      renderInput: ({ readonly }) => (
        <Input
          fullWidth
          value={values?.[FORM_FIELDS.EXTERNAL_PAYOUT_ID]}
          onChange={(value) => setFieldValue(FORM_FIELDS.EXTERNAL_PAYOUT_ID, value)}
          disabled={readonly}
          placeholder={t(LABELS.FORM_FIELDS.PLACEHOLDERS[FORM_FIELDS.EXTERNAL_PAYOUT_ID])}
        />
      ),
    },
  ];

  return (
    <Panel label={t(LABELS.TAX_REFUND_PANEL_TITLE)}>
      <FormContainer>
        <FormLayout fields={fields} readonly={readOnlyMode} error={error} />
      </FormContainer>
    </Panel>
  );
};
export default TaxRefundForm;
